import { FrameContextService } from '@qality/common-service';

export default {
  getIssueKey(): string {
    return FrameContextService.getContextParameter('issueKey');
  },

  getProjectIdOrKey(): string {
    return FrameContextService.getContextParameter('projectKey');
  },

  getProjectId(): string {
    return FrameContextService.getContextParameter('projectId');
  },

  getReportName(): string {
    return FrameContextService.getContextParameter('reportName');
  },
};
